import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ImageWrapper = ({width, height, children, className, onClick}) => (
  <div className={classNames('image-wrapper', className)} style={{width, height}} onClick={onClick}>
    {children}
  </div>
);

ImageWrapper.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};
ImageWrapper.defaultProps = {
  width: '100%',
  height: '100%',
};

export default ImageWrapper;
